import {Layout} from "@components/common";
import News, {getArticles} from "./index";
import {fetchJson, getShopNavigation, redirectTo404Page} from "../index";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";

const PAGE_SIZE = 9;

export async function getServerSideProps(context: any) {
  try {
    const { locale } = context;
    const url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}`;

    const articles = await getArticles(locale, 1, PAGE_SIZE, null, true);

    const sponsors = await fetchJson(
      url + '/api/sponsor-gallery?populate[0]=Sponsors.Url&populate[1]=Sponsors.Name&populate[2]=Sponsors.Logo',
      'data.attributes'
    );

    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        articles,
        sponsors,
        locale,
        U19: true
      }
    };
  } catch (error) {
    console.error(error)
    return  redirectTo404Page();
  }
}

export default News
News.Layout = Layout
